import React from 'react';
import SubPage from '../SubPage';
import { useLang } from '../../LanguageContext';

const CRUMB = { ko: '회사소개', en: 'About Us' };
const T = {
  title: { ko: '인사말', en: 'Greeting' },
  lede:  { ko: '기술로 돌봄의 부담을 덜고, 어르신의 존엄을 지키는 회사 메디로지스입니다.',
           en: 'MEDILOGIS eases the burden of care through technology while protecting the dignity of every resident.' },
  h2:    { ko: <>더 편안하고 정확한 돌봄,<br/>메디로지스가 만들어갑니다</>,
           en: <>Care that is more comfortable<br/>and more precise</> },
  p1:    { ko: '안녕하십니까. (주)메디로지스입니다.', en: 'Welcome to MEDILOGIS.' },
  p2:    { ko: '메디로지스는 IoT 센서와 실시간 모니터링 기술로 요양 현장의 돌봄 방식을 혁신하는 스마트 헬스케어 기업입니다. 스마트 기저귀에 부착된 IoT 센서가 24시간 배뇨·배변 상태를 감지하여 간병인에게 즉시 알리고, 수집된 데이터를 분석해 개인별 맞춤 케어 패턴을 제공합니다.',
           en: 'MEDILOGIS is a smart healthcare company transforming how care works on the ground, using IoT sensors and real-time monitoring. Sensors on the smart diaper detect urination and bowel movements around the clock, alert caregivers immediately, and the collected data is analyzed into a personalized care pattern for each resident.' },
  p3:    { ko: '정확한 교체 시점 안내로 욕창과 피부염을 예방하고, 데이터에 기반한 돌봄으로 요양보호사의 업무 부담을 줄이며 어르신의 건강과 존엄을 함께 지키는 것 — 그것이 메디로지스가 추구하는 가치입니다.',
           en: 'Precise change timing prevents pressure ulcers and dermatitis; data-driven care reduces the workload of caregivers. Protecting both health and dignity is the value we pursue.' },
  p5:    { ko: <>메디로지스는 장기요양인과 장애인, 영유아의 건강과 안전을 위하여 <strong>사물인터넷·인공지능·빅데이터</strong>를 활용한 제품과 서비스를 개발하는 소셜벤처 기업입니다. 요양 현장을 넘어 <strong>장애인 시설과 산후조리원</strong>까지, 돌봄이 필요한 모든 분들이 더 나은 환경에서 지내실 수 있도록 초고령사회를 대비해 나가겠습니다.</>,
           en: <>MEDILOGIS is a social venture developing products and services built on <strong>IoT, AI and big data</strong> for the health and safety of long-term care recipients, people with disabilities, and infants. Beyond nursing facilities — into <strong>disability care centers and postpartum care centers</strong> — we are preparing for a super-aged society.</> },
  sign:  { ko: '(주)메디로지스 임직원 일동', en: 'The MEDILOGIS Team' },
};

// 숫자는 본문에 박지 않는다 — /api/stats 를 쓰는 지표 바와 어긋나면 안 된다
const P4 = {
  ko: (h, t) => `현재 ${h}곳의 요양 기관이 메디로지스와 함께하고 있으며, ${t}건이 넘는 교체 감지 데이터가 더 나은 돌봄의 근거가 되고 있습니다. 앞으로도 현장의 목소리에 귀 기울이며 신뢰받는 스마트케어 파트너가 되겠습니다.`,
  en: (h, t) => `${h} care facilities work with MEDILOGIS today, and more than ${t} detection records are becoming the basis for better care. We will keep listening to the field and earn trust as a smart care partner.`,
};

function Greeting() {
  const { lang } = useLang();
  const [stats, setStats] = React.useState(null);
  React.useEffect(() => {
    let alive = true;
    fetch('/api/stats').then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (alive && d) setStats(d); }).catch(() => {});
    return () => { alive = false; };
  }, []);

  // 만 단위로 끊어 읽기 좋게 — 값이 없으면 문단 자체를 빼서 틀린 수치를 안 보인다
  const p4 = stats
    ? P4[lang](
        stats.hospital,
        lang === 'ko'
          ? `${Math.floor(stats.total / 10000)}만`
          : stats.total.toLocaleString('en-US')
      )
    : null;

  return (
    <SubPage crumb={CRUMB[lang]} title={T.title[lang]} lede={T.lede[lang]}>
      <div className="sp-two">
        <div>
          <div className="sp-label">GREETING</div>
          <h2>{T.h2[lang]}</h2>
        </div>
        <div className="sp-prose">
          <p>{T.p1[lang]}</p>
          <p>{T.p2[lang]}</p>
          <p>{T.p3[lang]}</p>
          {p4 && <p>{p4}</p>}
          <p>{T.p5[lang]}</p>
          <p style={{ marginTop: '2em', fontWeight: 700 }}>{T.sign[lang]}</p>
        </div>
      </div>
    </SubPage>
  );
}

export default Greeting;
